import { useState, useEffect } from "react";
import { useIsMobile, frameStyle } from "@/components/HeroStory";

// A full-bleed background that cross-fades between images.
// Includes the standard left + bottom legibility gradients.
export function CrossfadeBackground({ images, interval = 5000, breathe = true }) {
  const [active, setActive] = useState(0);
  const isMobile = useIsMobile();

  useEffect(() => {
    const t = setInterval(
      () => setActive((p) => (p + 1) % images.length),
      interval
    );
    return () => clearInterval(t);
  }, [images.length, interval]);

  return (
    <div className="absolute inset-0 z-0">
      {images.map((img, i) => (
        <img
          key={img.src}
          src={img.src}
          alt={i === active ? img.alt : ""}
          aria-hidden={i !== active}
          loading={i === 0 ? "eager" : "lazy"}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity ease-in-out ${
            breathe ? "animate-hero-breathe" : ""
          }`}
          style={{
            opacity: i === active ? 1 : 0,
            transitionDuration: "2000ms",
            ...frameStyle(img, isMobile),
          }}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/88 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-[#0a0a0a]/40" />
    </div>
  );
}
